var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_vm._v("\n  Hello World\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }